import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { generateQrCode } from '../../../../../assets/utility';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'collection-link-qr',
  templateUrl: './collection-link-qr.component.html',
  styleUrls: ['./collection-link-qr.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, NgClass],
})
export class CollectionLinkQrComponent implements OnInit, OnChanges {
  /**
   * The needed data if it was passed instead of fetching it from query params
   */
  @Input() data;

  /**
   * Indicator for using this component to preview instead of printing purposes
   */
  @Input() isPreview: boolean;

  link: string;
  businessName: string;
  qrCode: string;
  ussdCode: string;
  merchantNo: Array<string>;

  constructor(private activeRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const { link, business, ussd_code, merchant_code, is_ug } = this.data || this.activeRoute.snapshot.queryParams;
    const opts = {
      errorCorrectionLevel: 'H',
      margin: 0,
    };

    this.link = decodeURIComponent(link);
    this.businessName = decodeURIComponent(business);

    if (is_ug === 'true') {
      this.ussdCode = ussd_code && decodeURIComponent(ussd_code);
      this.merchantNo = merchant_code && decodeURIComponent(merchant_code).split('');
    }

    generateQrCode(this.link, opts)
      .then((qrStr) => {
        this.qrCode = qrStr;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }
}
